import { z } from "zod";
import { optional } from "./appointments";
import { recordId } from "./contracts";

export const WEEKDAYS = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"] as const;

export const weekday = z.enum(WEEKDAYS);
export type Weekday = z.infer<typeof weekday>;

export const availabilityTime = z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/, "expected HH:mm");

export const availableHours = z
  .object({ start: availabilityTime, end: availabilityTime })
  .strict()
  .refine(({ start, end }) => start < end, { message: "a day's start is before its end", path: ["end"] });
export type AvailableHours = z.infer<typeof availableHours>;

const day = availableHours.nullable();

export const availabilityDays = z
  .object({ monday: day, tuesday: day, wednesday: day, thursday: day, friday: day, saturday: day, sunday: day })
  .strict();
export type AvailabilityDays = z.infer<typeof availabilityDays>;

export const availability = z.object({ days: availabilityDays, updatedAt: z.string().nullable() });
export type Availability = z.infer<typeof availability>;

const actingOrganization = optional(recordId.toLowerCase());

export const availabilityReadQuery = z.object({ actingOrganization });
export type AvailabilityReadQuery = z.infer<typeof availabilityReadQuery>;

export const availabilityRequest = z.object({ actingOrganization, days: availabilityDays }).strict();
export type AvailabilityRequest = { actingOrganization?: string; days: AvailabilityDays };
